import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

export const updateEngagementTitle = (
  requestTypeDetails?: any,
  clientName?: string,
  engagementName?: string,
  path?: string
): ReactNode => {
  const defaultTitle = "";
  let newTitle = "";
  let headerTitle: ReactNode = "Dashboard";

  const truncateText = (text: string, maxLength: number) => {
    if (text.length > maxLength) {
      return text.slice(0, maxLength) + "...";
    }
    return text;
  };

  if (path === "/engagements") {
    newTitle = "Active Engagements";
    headerTitle = "Active Engagements";
  } 
  else if (path === "/requests") {
    newTitle = requestTypeDetails?.requestTypeName || '';
    headerTitle = requestTypeDetails?.requestTypeName;
  }
  else if (path === "/viewrequests/" || path?.startsWith("/viewrequests")) { 
    
    const requestTypeDetailsFromStorage = localStorage.getItem('lastRequestBreadcrumb') ? JSON.parse(localStorage.getItem('lastRequestBreadcrumb') || '') : null;
    const breadcrumb = requestTypeDetails?.breadcrumb || requestTypeDetailsFromStorage?.breadcrumb || [];    
    newTitle = requestTypeDetails?.requestTypeName || "";
    if (breadcrumb.length) {
      headerTitle = (
        <div className="breadcrumb">
          {breadcrumb.map((item, index) => (
            <span key={item.index ?? index}>
              {item.path ? (
                <Link
                  to={item.path}
                  style={{ color: "inherit", textDecoration: "none", cursor: "pointer" }}
                >
                  {item.label}
                </Link>
              ) : (
                <span>{item.label}</span>
              )}
              {index < breadcrumb.length - 1 && " | "}
            </span>
          ))}
        </div>
      );
    } else {
      headerTitle = requestTypeDetails?.requestTypeName || "";
    }
  } else if (path?.includes("/overview/") || path?.includes("/monitor/") || path?.includes("/budget/") || path?.includes("/requests/") || path?.includes("/timeentries/") || path?.includes("/workflow/") || path?.includes("/expenses/")) {    if (clientName && engagementName) {
      newTitle = `${clientName} | ${engagementName}`;
      headerTitle = (
        <div className="client-container flex-wrap" title={`${clientName} | ${engagementName}`}>
          <span className="client-name" title={clientName}>{clientName}</span>
          <i
            className="pi pi-angle-right text-lg flex align-items-center justify-content-center font-light "></i>
          <span className="engagement-name" title={engagementName}>{engagementName}</span>
        </div>
      );
    } else {
      newTitle = "Dashboard";
      headerTitle = "Dashboard";
    }
  } 
  else if (path === "/time-report") {
    newTitle = 'Time Report';
    headerTitle = 'Time Report';
  } else if (path === "/admin" || path?.startsWith("/admin/")) {
    newTitle = 'Admin';
    headerTitle = 'Admin';
  } else {
    newTitle = "Dashboard";
    headerTitle = "Dashboard";
  }

  document.title = newTitle ? `${defaultTitle} ${newTitle}` : defaultTitle;
  return headerTitle;
};

export const ApplyRedColor = (input1: any, input2: any) => {
  if (Number(input1) > Number(input2)) {
    return "text-red-500 font-medium width-box";
  }
};

export const ApplyFooterRedColor = (input1: any, input2: any) => {
  if (Number(input1) > Number(input2)) {
    return "text-sm text-red-500";
  }
};

export const ApplyStaffRedColor = (EngagementStaffId: any) => {
  if (EngagementStaffId === null || EngagementStaffId === '') {
    return "text-red-500 font-semibold inline-block white-space-nowrap overflow-hidden text-overflow-ellipsis w-120";
  }
  else {
    return "font-semibold inline-block white-space-nowrap overflow-hidden text-overflow-ellipsis w-120";
  }
};

export const ApplyWipPercentageMonitorCardStyle = (percentageValue: number): string => {
  if (percentageValue <= 0) {
    return "custom-card border-left-blue flex justify-content-center align-items-center h-4rem border-noround";
  }
  else if ((percentageValue * 100) > 100) {
    return "custom-card border-left-red flex justify-content-center align-items-center h-4rem border-noround";
  }
  else {
    return "custom-card border-left-green flex justify-content-center align-items-center h-4rem border-noround";
  }
};
export const ApplyRealizationMonitorCardStyle = (percentageValue: number): string => {
  if (percentageValue <= 0) {
    return "custom-card border-left-blue flex justify-content-center align-items-center h-4rem border-noround";
  }
  else if ((percentageValue * 100) > 100) {
    return "custom-card border-left-green flex justify-content-center align-items-center h-4rem border-noround";

  }
  else {
    return "custom-card border-left-red flex justify-content-center align-items-center h-4rem border-noround";
  }
};